<template>
  <div id="graphic-static-atype">
    <div class="ipub-block mar-b-30">
      <atypePie-chart></atypePie-chart>
    </div>
    <div class="">
      <current-remind></current-remind>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>